export * from './localization';

export const CUSTOMER_SERVICE = {
  PHONE: '+358 20 334 443',
  PHONE_SIMPLE: '020 334 443',
  EMAIL: 'asiakaspalvelu@sato.fi',
};

export const BIC = {
  HELSFIHH: 'Aktia',
  BIGKFIH1: 'Bigbank',
  CITIFIHX: 'Citibank',
  DABAFIHH: 'Danske Bank',
  DABAFIHX: 'Danske Bank',
  DNBAFIHX: 'DnB NOR Bank',
  HANDFIHH: 'Handelsbanken',
  HOLVFIHH: 'Holvi',
  NDEAFIHH: 'Nordea',
  OMASP: 'OmaSp',
  OKOYFIHH: 'Osuuspankki',
  POPFFI22: 'POP Pankki',
  SBANFIHH: 'S-Pankki',
  ESSEFIHX: 'SEB',
  SWEDFIHH: 'Swedbank',
  ITELFIHH: 'Säästöpankki',
  AABAFI22: 'Ålandsbanken',
};

// Service request title
export const TOPIC_MAX_LENGTH = 150;
// Service request body
export const BODY_MAX_LENGTH = 1800;

/** Contract is considered as a new contract if it's this many days old or less */
export const CONTRACT_IS_CONSIDERED_NEW_DAYS = 10;

/**
 * Apartment is considered "new"/"fresh" if less than this many years have passed from its construction or renovation.
 *
 * Example: We restrict the user from ordering a painting kit if the apartment has just been renovated.
 */
export const APARTMENT_IS_CONSIDERED_NEW_YEARS = 2;
